function Navbar() {
    return (
        <div class="navbar">
            <h1>Anime Gallery</h1>

            <input type="text" class="nav_1" placeholder=" Search for the Epic"></input>
        </div>
    )


}

export default Navbar;


